// © Microsoft Corporation. All rights reserved.

import {
    SocialCommentProps as BaseSocialCommentProps,
    SocialCommentUnhandledProps as BaseSocialCommentUnhandledProps,
    SocialCommentHandledProps,
    SocialCommentManagedClasses
} from "./SocialComment.props";
import { SocialCommentConfigSchema, mockConfig, mockDefaultState, mockState } from "./experience-info";
import manageJss, { ManagedJSSProps } from "@microsoft/fast-jss-manager-react";

import { SocialComment as BaseSocialComment } from "./SocialComment";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { ExperienceInfo } from "@msnews/core";
import { SocialCommentActions } from "./SocialComment.actions";
import { SocialCommentClassNameContract } from "./SocialComment.classnames";
import { SocialCommentConfig } from "./SocialComment.config";
import { SocialCommentConnector } from "./SocialComment.connector";
import { SocialCommentInspector } from "./SocialComment.inspector";
import { SocialCommentReducer } from "./SocialComment.reducer";
import { SocialCommentState } from "./SocialComment.state";
import { SocialCommentStyle } from "./SocialComment.styles";
import { Subtract } from "utility-types";

// The type returned by manageJss type is very complicated so we'll let the compiler infer the type instead of re-declaring just for the package export
const SocialComment = manageJss(SocialCommentStyle)(BaseSocialComment);
type SocialComment = InstanceType<typeof SocialComment>;

// Create a valid JSS managed interface that doesn't require managed classes which are provided by the manageJSS HOC
type SocialCommentUnhandledProps = Subtract<BaseSocialCommentUnhandledProps, SocialCommentManagedClasses>;

// Create type for manageJSS HOC styled instance we are exporting
type SocialCommentProps = ManagedJSSProps<BaseSocialCommentProps, SocialCommentClassNameContract, DesignSystem>;

// Define the ExperienceInfo object. This is used by tooling
const ToolingInfo: ExperienceInfo<SocialCommentConfig, SocialCommentState, any, any> = {
    reactComponent: SocialComment,
    experienceConfigSchema: SocialCommentConfigSchema,
    defaultMockState: mockDefaultState,
    mockState: mockState,
    mockConfig: mockConfig,
    inspector: SocialCommentInspector.inspect
};

// Export everything a user might need from this index file
export {
    SocialComment,
    SocialCommentActions as CommentActions,
    SocialCommentConfig,
    SocialCommentConnector,
    SocialCommentProps,
    SocialCommentReducer,
    SocialCommentState,
    SocialCommentClassNameContract,
    SocialCommentHandledProps,
    SocialCommentUnhandledProps,
    ToolingInfo
};

